export interface MItemSectionProps {
  avatar?: boolean;
}

export const mItemSectionDefaults = {
  avatar: false,
} satisfies Partial<MItemSectionProps>;
